// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MinusComponent} from './Minus.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMinus = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MinusComponent/>
  </Icon>
));
